import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "user-profile" }
const _hoisted_3 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexProfile',
  setup(__props) {

const profileHeader = defineAsyncComponent(() => import("@/components/theme/user/profile/profileHeader.vue"))
const profilePost = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost.vue"))
const profilePost1 = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost1.vue"))
const profilePost2 = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost2.vue"))
const profilePost3 = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost3.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Users",
      title: "User Profile"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(profileHeader)),
          _createVNode(_unref(profilePost)),
          _createVNode(_unref(profilePost1)),
          _createVNode(_unref(profilePost2)),
          _createVNode(_unref(profilePost3))
        ])
      ])
    ])
  ], 64))
}
}

})